import { BannerId } from '../../../typings/banners';

export const UPDATE_INTERNAL_BANNER_DESCRIPTION = 'UPDATE_INTERNAL_BANNER_DESCRIPTION';
export type UPDATE_INTERNAL_BANNER_DESCRIPTION = typeof UPDATE_INTERNAL_BANNER_DESCRIPTION;
export interface UpdateInternalBannerDescription {
    type: UPDATE_INTERNAL_BANNER_DESCRIPTION;
    bannerId: BannerId;
    value: string;
}

export function updateInternalBannerDescriptionAction(
    bannerId: BannerId,
    value: string
): UpdateInternalBannerDescription {
    return {
        type: UPDATE_INTERNAL_BANNER_DESCRIPTION,
        bannerId,
        value
    };
}
